module.exports = {
  "genericUpgradeEvent": {
    "name": "placeholder-definition-dont-use",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "externalLinkClick": {
    "name": "external-link-click",
    "class": "interaction",
    "properties": {
      "name": "string"
    },
    "namespace": "upgrades"
  },
  "usageLimitUpgradeEvent": {
    "name": "placeholder-definition-dont-use",
    "class": "interaction",
    "properties": {
      "action": "string",
      "hasReachedLimit": "boolean",
      "value": "number",
      "limit": "number",
      "currencyCode": {
        "type": "string",
        "isOptional": true
      },
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": "string",
      "app": "string",
      "screen": "string",
      "type": "string",
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": "string"
    },
    "namespace": "upgrades"
  },
  "communicationMethodsInteraction": {
    "name": "communication-methods",
    "class": "interaction",
    "properties": {
      "meetingLink": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "contactSalesButtonInteraction": {
    "name": "contact-sales-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "contactSalesModalInteraction": {
    "name": "contact-sales-modal",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "experimentExposure": {
    "name": "experiment-exposure",
    "class": "exposure",
    "properties": {
      "experimentGroup": "string",
      "experimentNamespace": "string",
      "experimentName": "string"
    },
    "namespace": "upgrades"
  },
  "lockedAppInteraction": {
    "name": "locked-app",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "lockedFeatureInteraction": {
    "name": "locked-feature",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "lockedFeatureBannerInteraction": {
    "name": "locked-feature-banner",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "pricingPageRedirectButtonInteraction": {
    "name": "pricing-page-redirect-button",
    "class": "interaction",
    "properties": {
      "upgradeProduct": "string",
      "source": "string"
    },
    "namespace": "upgrades"
  },
  "productActivationButtonInteraction": {
    "name": "product-activation-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "productActivationInteraction": {
    "name": "product-activation",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "trialActivationButtonInteraction": {
    "name": "trial-activation-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "trialActivationInteraction": {
    "name": "trial",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "expiredTrialModalInteraction": {
    "name": "expired-trial-modal",
    "class": "interaction",
    "properties": {
      "action": "string",
      "app": "string",
      "screen": "string",
      "upgradeProduct": "string",
      "uniqueId": "string"
    },
    "namespace": "upgrades"
  },
  "trialActivationRedirected": {
    "name": "trial-activation-redirected",
    "class": "interaction",
    "properties": {
      "redirectTarget": "string",
      "product": "string",
      "app": "string",
      "screen": "string",
      "type": "string",
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": "string"
    },
    "namespace": "upgrades"
  },
  "upgradeButtonInteraction": {
    "name": "upgrade-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "upgradeModalInteraction": {
    "name": "upgrade-modal",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "usageLimitInteraction": {
    "name": "usage-limit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "hasReachedLimit": "boolean",
      "value": "number",
      "limit": "number",
      "currencyCode": {
        "type": "string",
        "isOptional": true
      },
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": "string",
      "app": "string",
      "screen": "string",
      "type": "string",
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": "string"
    },
    "namespace": "upgrades"
  },
  "viewUpgradeAdminPrompt": {
    "name": "view-upgrade-admin-prompt",
    "class": "interaction",
    "namespace": "upgrades"
  },
  "checkoutButtonInteraction": {
    "name": "checkout-button",
    "class": "interaction",
    "properties": {
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "currencyCode": {
        "type": "string"
      },
      "termName": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "isQuantityUpgrade": {
        "type": "boolean"
      },
      "merchandiseNames": {
        "type": "array",
        "isOptional": true
      },
      "merchandiseIds": {
        "type": "array",
        "isOptional": true
      },
      "productBasedOfferNames": {
        "type": "array",
        "isOptional": true
      },
      "productBasedOfferIds": {
        "type": "array"
      },
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": "string",
      "app": "string",
      "screen": "string",
      "type": "string",
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": "string"
    },
    "namespace": "upgrades"
  },
  "errorInteraction": {
    "name": "error",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "pqlInteraction": {
    "name": "pql",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotionEligibility": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "app": "string",
      "screen": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": {
        "type": "string",
        "isOptional": true
      },
      "termId": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "requestUpgradeInteraction": {
    "name": "request-upgrade",
    "class": "interaction",
    "properties": {
      "action": "string",
      "merchandiseId": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "upgrades"
  },
  "requestSeatBannerInteraction": {
    "name": "request-seat-banner",
    "class": "interaction",
    "properties": {
      "banner": "string",
      "action": "string",
      "product": "string",
      "app": "string",
      "screen": "string",
      "type": "string",
      "source": "string",
      "upgradeProduct": "string",
      "uniqueId": "string",
      "campaign": "string"
    },
    "namespace": "upgrades"
  }
};